/**
 * 基地推荐管理页面 - 简化版
 */
import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function BaseReferral() {
  const [referrals, setReferrals] = useState([])
  const [stats, setStats] = useState({})
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState('list')
  const [form, setForm] = useState({
    referrerName: '', referrerPhone: '', baseName: '', baseType: '机构基地', address: '', contact: '', phone: ''
  })
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => { loadData() }, [])

  const loadData = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${API}/base-referral/list?limit=50`)
      const data = await res.json()
      if (data.success) {
        setReferrals(data.data || [])
        setStats(data.stats || {})
      }
    } catch (e) { console.error(e) }
    finally { setLoading(false) }
  }

  const handleSubmit = async () => {
    if (!form.referrerName || !form.referrerPhone || !form.baseName || !form.phone) {
      alert('请填写必填项')
      return
    }
    setSubmitting(true)
    try {
      const res = await fetch(`${API}/base-referral/submit`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form)
      })
      const data = await res.json()
      if (data.success) {
        alert(`推荐成功！\n基础奖励：¥${data.data.baseReward}\n额外奖励：¥${data.data.extraReward}\n总计：¥${data.data.totalReward}`)
        setTab('list')
        loadData()
        setForm({ referrerName: '', referrerPhone: '', baseName: '', baseType: '机构基地', address: '', contact: '', phone: '' })
      } else {
        alert(data.error || '提交失败')
      }
    } catch (e) { alert('提交失败') }
    finally { setSubmitting(false) }
  }

  const handleApprove = async (id, status) => {
    if (!confirm(`确定${status === 'approved' ? '批准' : '拒绝'}？`)) return
    try {
      const res = await fetch(`${API}/base-referral/approve/${id}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status })
      })
      const data = await res.json()
      if (data.success) { alert(data.message); loadData() }
      else alert(data.error)
    } catch (e) { alert('操作失败') }
  }

  const handleExtraReward = async (id) => {
    if (!confirm('确定发放额外奖励？\n（需确认基地已首次使用系统）')) return
    try {
      const res = await fetch(`${API}/base-referral/extra/${id}`, { method: 'POST' })
      const data = await res.json()
      if (data.success) { alert(data.message); loadData() }
      else alert(data.error)
    } catch (e) { alert('操作失败') }
  }

  const cardStyle = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
  const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }

  const getStatusBadge = (r) => {
    if (r.status === 'rejected') return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#fff1f0', color: '#ff4d4f' }}>已拒绝</span>
    if (r.status === 'pending') return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#fffbe6', color: '#faad14' }}>待审核</span>
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#e6f7ff', color: '#1890ff' }}>已批准</span>
        {r.base_settled ? (
          <span style={{ fontSize: 10, color: '#52c41a' }}>✅基础奖励已发</span>
        ) : (
          <span style={{ fontSize: 10, color: '#faad14' }}>⏳基础奖励待发</span>
        )}
      </div>
    )
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, margin: 0 }}>🏕️ 基地推荐</h2>
        <button onClick={loadData} style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>🔄 刷新</button>
      </div>

      {/* 统计 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>推荐总数</div><div style={{ fontSize: 28, color: '#1890ff' }}>{stats.total || 0}</div></div>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>已批准</div><div style={{ fontSize: 28, color: '#52c41a' }}>{stats.approved || 0}</div></div>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>待审核</div><div style={{ fontSize: 28, color: '#faad14' }}>{stats.pending || 0}</div></div>
        <div style={cardStyle}><div style={{ color: '#999', fontSize: 12 }}>已发奖励</div><div style={{ fontSize: 28, color: '#722ed1' }}>¥{stats.totalReward || 0}</div></div>
      </div>

      {/* 标签页 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <button onClick={() => setTab('list')} style={{ padding: '8px 20px', background: tab === 'list' ? '#1890ff' : '#f5f5f5', color: tab === 'list' ? '#fff' : '#666', border: 'none', borderRadius: 6, cursor: 'pointer' }}>推荐记录</button>
        <button onClick={() => setTab('submit')} style={{ padding: '8px 20px', background: tab === 'submit' ? '#1890ff' : '#f5f5f5', color: tab === 'submit' ? '#fff' : '#666', border: 'none', borderRadius: 6, cursor: 'pointer' }}>📝 推荐新基地</button>
        <button onClick={() => setTab('rules')} style={{ padding: '8px 20px', background: tab === 'rules' ? '#1890ff' : '#f5f5f5', color: tab === 'rules' ? '#fff' : '#666', border: 'none', borderRadius: 6, cursor: 'pointer' }}>💡 奖励规则</button>
      </div>

      {tab === 'list' && (
        <div style={cardStyle}>
          {loading ? <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>加载中...</div>
          : referrals.length === 0 ? <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无推荐记录</div>
          : (
            <div style={{ overflow: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr style={{ background: '#fafafa' }}>
                  <th style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>推荐人</th>
                  <th style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>被推荐基地</th>
                  <th style={{ padding: 12, textAlign: 'right', fontSize: 13, color: '#666' }}>基础奖励</th>
                  <th style={{ padding: 12, textAlign: 'right', fontSize: 13, color: '#666' }}>额外奖励</th>
                  <th style={{ padding: 12, textAlign: 'center', fontSize: 13, color: '#666' }}>状态</th>
                  <th style={{ padding: 12, textAlign: 'center', fontSize: 13, color: '#666' }}>操作</th>
                </tr></thead>
                <tbody>
                  {referrals.map(r => (
                    <tr key={r.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: 12 }}><div style={{ fontWeight: 500 }}>{r.referrer_name}</div><div style={{ fontSize: 12, color: '#999' }}>{r.referrer_phone}</div></td>
                      <td style={{ padding: 12 }}><div style={{ fontWeight: 500 }}>{r.base_name}</div><div style={{ fontSize: 12, color: '#999' }}>{r.base_type} · {r.phone}</div></td>
                      <td style={{ padding: 12, textAlign: 'right' }}><span style={{ color: r.base_settled ? '#52c41a' : '#999' }}>¥{r.base_reward || 200}</span></td>
                      <td style={{ padding: 12, textAlign: 'right' }}><span style={{ color: r.extra_settled ? '#52c41a' : '#999' }}>¥{r.extra_reward || 300}</span></td>
                      <td style={{ padding: 12, textAlign: 'center' }}>{getStatusBadge(r)}</td>
                      <td style={{ padding: 12, textAlign: 'center' }}>
                        {r.status === 'pending' && (
                          <><button onClick={() => handleApprove(r.id, 'approved')} style={{ padding: '4px 12px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 4 }}>批准</button>
                          <button onClick={() => handleApprove(r.id, 'rejected')} style={{ padding: '4px 12px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>拒绝</button></>
                        )}
                        {r.status === 'approved' && !r.extra_settled && (
                          <button onClick={() => handleExtraReward(r.id)} style={{ padding: '4px 12px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>发放额外奖励</button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {tab === 'submit' && (
        <div style={cardStyle}>
          <h3 style={{ margin: '0 0 20px', fontSize: 16 }}>📝 推荐新基地</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div><label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>推荐人姓名 *</label><input type="text" value={form.referrerName} onChange={e => setForm({...form, referrerName: e.target.value})} placeholder="您的姓名" style={inputStyle} /></div>
            <div><label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>推荐人手机 *</label><input type="tel" value={form.referrerPhone} onChange={e => setForm({...form, referrerPhone: e.target.value})} placeholder="手机号" maxLength={11} style={inputStyle} /></div>
            <div><label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>基地名称 *</label><input type="text" value={form.baseName} onChange={e => setForm({...form, baseName: e.target.value})} placeholder="基地名称" style={inputStyle} /></div>
            <div><label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>基地类型</label><select value={form.baseType} onChange={e => setForm({...form, baseType: e.target.value})} style={inputStyle}><option>机构基地</option><option>企业基地</option><option>独立基地</option></select></div>
            <div><label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>联系电话 *</label><input type="tel" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="电话" maxLength={11} style={inputStyle} /></div>
            <div><label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>联系人</label><input type="text" value={form.contact} onChange={e => setForm({...form, contact: e.target.value})} placeholder="联系人" style={inputStyle} /></div>
            <div style={{ gridColumn: '1 / -1' }}><label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>详细地址</label><input type="text" value={form.address} onChange={e => setForm({...form, address: e.target.value})} placeholder="地址" style={inputStyle} /></div>
          </div>
          <div style={{ marginTop: 20 }}>
            <button onClick={handleSubmit} disabled={submitting} style={{ padding: '12px 32px', background: submitting ? '#d9d9d9' : '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: submitting ? 'not-allowed' : 'pointer', fontSize: 15 }}>{submitting ? '提交中...' : '提交推荐'}</button>
          </div>
        </div>
      )}

      {tab === 'rules' && (
        <div style={cardStyle}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>💡 基地推荐奖励规则</h3>
          <div style={{ lineHeight: 2, fontSize: 14, color: '#666' }}>
            <div style={{ marginBottom: 16 }}>
              <strong>推荐奖励（分两阶段发放）</strong>
              <table style={{ marginLeft: 20, marginTop: 8, border: '1px solid #f0f0f0' }}>
                <tr style={{ background: '#fafafa' }}><th style={{ padding: '8px 16px', textAlign: 'left' }}>阶段</th><th style={{ padding: '8px 16px', textAlign: 'right' }}>奖励金额</th><th style={{ padding: '8px 16px', textAlign: 'left' }}>触发条件</th></tr>
                <tr><td style={{ padding: '8px 16px' }}>① 基础奖励</td><td style={{ padding: '8px 16px', textAlign: 'right', color: '#52c41a' }}>¥200</td><td style={{ padding: '8px 16px' }}>审核通过</td></tr>
                <tr><td style={{ padding: '8px 16px' }}>② 额外奖励</td><td style={{ padding: '8px 16px', textAlign: 'right', color: '#52c41a' }}>¥300</td><td style={{ padding: '8px 16px' }}>基地首次使用/首单</td></tr>
                <tr style={{ background: '#f6ffed', fontWeight: 'bold' }}><td style={{ padding: '8px 16px' }}>总计</td><td style={{ padding: '8px 16px', textAlign: 'right' }}>¥500</td><td style={{ padding: '8px 16px' }}></td></tr>
              </table>
            </div>
            <div>
              <strong>谁可以推荐？</strong>
              <div style={{ marginLeft: 20 }}>任何人！不需要注册，只要推荐即可。</div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
